export default __webpack_public_path__ + "static/media/update.2f64a45e.svg";